import { browserHistory } from 'react-router';
import { delay, all, call, fork, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as api from '../../services/unit_of_measure_type/api_unit_of_measure_type';
import * as apiCommon from '../../services/apiCommon';
import {
  showProgressListTable,
  doneListTable,
  showErrorListTable,
  doneSaveRecord,
  showErrorSaveRecord,
  doneDataById,
  showProgressDeleteRecord,
  showErrorDeleteRecord,
  showProgressDataById,
  showErrorDataById,
  doneDeleteRecord,
  showProgressSaveRecord
} from '../sagasCommon';
import { UNIT_OF_MEASURE_TYPE } from '../../constants/constant_doc_types';
import { SIMPLE_FORM_SET_DATA } from '../../constants/constant_saga_types';


export default function*(app) {
  try {
    yield all([
      fork(fetchListUnitOfMeasureTypeSaga, app),
      fork(saveUnitOfMeasureTypeSaga, app),
      fork(deleteUnitOfMeasureTypeFromListSaga, app),
      fork(deleteUnitOfMeasureTypeSaga, app),
      fork(fetchUnitOfMeasureTypeForEditSaga, app),
    ]);
  } catch (e) {
    console.error('@saga_unit_of_measure_type: ', e.message || e.stack);
    throw e;
  }
}


function* fetchListUnitOfMeasureTypeSaga(feathersApp) {
  yield takeLatest(
    'FETCH_LIST_UNIT_OF_MEASURE_TYPE',
    callFetchListUnitOfMeasureType,
    feathersApp
  );
}

function* callFetchListUnitOfMeasureType(feathersApp, action) {
  const { silent, filters } = action;
  yield showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type: UNIT_OF_MEASURE_TYPE,
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield showErrorListTable(error);
  }
}

function* saveUnitOfMeasureTypeSaga(feathersApp) {
  yield takeEvery('SAVE_UNIT_OF_MEASURE_TYPE', callSaveUnitOfMeasureType, feathersApp);
}

function* callSaveUnitOfMeasureType(feathersApp, action) {
  const { tenant, user } = yield select();
  try {
    yield showProgressSaveRecord();

    const params = { tenant, user, data: action.data };
    const result = yield call(api.saveUnitOfMeasureType, feathersApp, params);

    yield doneSaveRecord(result, 'Unit of measure type  was saved');
    yield put({ type: SIMPLE_FORM_SET_DATA, data: result });
    yield callFetchListUnitOfMeasureType(feathersApp, { silent: true });
  } catch (e) {
    yield showErrorSaveRecord(e);
  }
}

function* deleteUnitOfMeasureTypeFromListSaga(feathersApp) {
  yield takeEvery(
    'DELETE_UNIT_OF_MEASURE_TYPE_FROM_LIST',
    callDeleteUnitOfMeasureTypeFromList,
    feathersApp
  );
}

function* callDeleteUnitOfMeasureTypeFromList(feathersApp, action) {
  yield deleteUnitOfMeasureType(feathersApp, action);
  yield delay(2000);
  yield callFetchListUnitOfMeasureType(feathersApp, { silent: true });
}

function* deleteUnitOfMeasureType(feathersApp, action) {
  yield showProgressDeleteRecord();
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const params = { tenant, user, id };
      result = yield call(api.deleteUnitOfMeasureType, feathersApp, params);
      yield doneDeleteRecord(id, UNIT_OF_MEASURE_TYPE);
      yield callFetchListUnitOfMeasureType(feathersApp, { silent: true });
    }
    return result;
  } catch (error) {
    yield showErrorDeleteRecord(error);
  }
}

function* deleteUnitOfMeasureTypeSaga(feathersApp) {
  yield takeEvery('DELETE_UNIT_OF_MEASURE_TYPE', callDeleteUnitOfMeasureType, feathersApp);
}

function* callDeleteUnitOfMeasureType(feathersApp, action) {
  const result = yield deleteUnitOfMeasureType(feathersApp, action);
  yield delay(2000);
  if (result) {
    browserHistory.push('/admin/unit_of_measure_type');
  }
}

function* fetchUnitOfMeasureTypeForEditSaga(feathersApp) {
  yield takeEvery(
    'FETCH_UNIT_OF_MEASURE_TYPE_BY_ID',
    callFetchUnitOfMeasureTypeForEdit,
    feathersApp
  );
}

function* callFetchUnitOfMeasureTypeForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id } = action;
  try {
    if (id) {
      yield showProgressDataById();
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchUnitOfMeasureTypeById, feathersApp, fetchParams);
      yield doneDataById(doc);
      yield put({
        type: SIMPLE_FORM_SET_DATA,
        data: doc,
      });
    }
  } catch (error) {
    yield showErrorDataById(error);
  }
}
